import Vue from 'vue'
import authHeader from './auth-header'

class MemberService {
  search (params) {
    return Vue.axios.get('members', { params: params, headers: authHeader() })
  }
}

export default new MemberService()
